import type { FcSubscribedDiscountProduct } from "~/components/broadband-consumer/FixedConsumerOrder/types/subscriptionDetails";

interface LegacyAddonSummaryTile {
	name: string;
	amount: string;
}

export const toFixedAddonSummaryProduct = (discount: FcSubscribedDiscountProduct): LegacyAddonSummaryTile => ({
	name: discount.publicName,
	amount: "1 stk",
});

// All KAS TV subscriptions connected to a CVC subscription will get this postfix from the API
export const KAS_CVC_BB_POSTFIX = "_CVCBB";
